import app from '../../scripts/app';
import { trackSelectIdentification } from './verification-task.tracking';
import template from './verification-task.jade';

const verificationTaskController = [
  '$scope',
  '$rootScope',
  '$timeout',
  'userIdentificationService',
  function ($scope, $rootScope, $timeout, userIdentificationService) {
    $scope.getTask = () => {
      return userIdentificationService
        .getTaskList()
        .find(item => item.identificationServiceType === $scope.task.identificationServiceType);
    };

    $scope.$watch(
      userIdentificationService.getUserStatus,
      (newVal, oldVal) => {
        if ($scope.task.identificationServiceType === 'gosuslugi') {
          if (newVal === 'identified' || oldVal === 'identified') {
            userIdentificationService.setIsSelectPageVisible(false);
            userIdentificationService.resetGosuslugiPromise();
            $rootScope.$emit('callShowPublishSuccess');
          } else {
            userIdentificationService.checkAvailableTasks().then(() => {
              $timeout(function () {
                $scope.$apply();
              });
            });
            if (newVal === 'previousAttemptFailedShouldRetry') {
              userIdentificationService.resetGosuslugiPromise();
            }
          }
        }
      },
      true,
    );

    this.onSelect = () => {
      trackSelectIdentification($scope.task.analyticsKey);
      userIdentificationService.onSelectIdentification($scope.task);
    };
  },
];

const verificationTaskDirective = [
  function () {
    return {
      template,
      scope: {
        task: '=',
      },
      bindToController: {},
      controller: verificationTaskController,
      controllerAs: 'verificationTaskCtrl',
    };
  },
];

app.directive('verificationTask', verificationTaskDirective);
